import ItemScannerGlobal from './ItemScanner';

export const ItemScannerGlobalActions = ItemScannerGlobal.actions;
export const ItemScannerGlobalReducer = ItemScannerGlobal.reducer;
